import { render, staticRenderFns } from "./ConfirmationPopup.vue?vue&type=template&id=5174c6b1"
import script from "./ConfirmationPopup.vue?vue&type=script&lang=js"
export * from "./ConfirmationPopup.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationPopup.vue?vue&type=style&index=0&id=5174c6b1&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5174c6b1')) {
      api.createRecord('5174c6b1', component.options)
    } else {
      api.reload('5174c6b1', component.options)
    }
    module.hot.accept("./ConfirmationPopup.vue?vue&type=template&id=5174c6b1", function () {
      api.rerender('5174c6b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/ConfirmationPopup.vue"
export default component.exports